import { useQuery } from '@tanstack/react-query';
import { environment } from 'src/environment';
import { fetcher } from '$shared/fetch';

export type FeatureToggle = 'ESEVNLS_5067_DELETE_ORGANIZATION';

export const fetchFeatureToggles = async (): Promise<Record<FeatureToggle, boolean>> => {
  const response = await fetcher.get<{ data: string[] }>('/app-config-service/backoffice/feature-toggles', environment.visionizeApiUrl);
  const featureToggles = Object.fromEntries(response.data.map((flag) => [flag, true]));

  return featureToggles as Record<FeatureToggle, boolean>;
};

export const useFeatureToggles = (): Partial<Record<FeatureToggle, boolean>> => {
  const { data: featureToggles = {} } = useQuery({
    queryKey: ['featureToggles'],
    queryFn: fetchFeatureToggles,
  });

  return featureToggles;
};
